export const documentDrawerData: any = {
  items: [],
  id: null,
  formMode: "create",
  disableFormFields: false,
};
